import {FC, useRef, useEffect, useState} from 'react'
import {shallowEqual, useSelector, connect, useDispatch, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as auth from './AuthRedux'
import {getUserByToken} from './AuthCRUD'
import {RootState} from '../../../../setup'
import {PermissionsClient} from '../../../infrastracture/api/PermissionsClient'
import {AccountSettingsClient} from '../../../infrastracture/api/AccountSettingsClient'
import * as accountSettings from '../../account-themes/redux/AccountSettingRedux'
import {ChartColors, ChartLabels} from '../../../common/constants/chartColors'
import React from 'react'
import {fetchAccountSettings} from '../../../../setup/redux/accountSettingsThunk'

const mapState = (state: RootState) => ({auth: state.auth})
const connector = connect(mapState, auth.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const AuthInit: FC<PropsFromRedux> = (props) => {
  const didRequest = useRef(false)
  const dispatch = useDispatch()
  const [showSplashScreen, setShowSplashScreen] = useState(true)
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)

  // We should request user by authToken before rendering the application
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const result = (await getUserByToken()) as any

          if (result && result?.data) {
            const {data: user} = result

            dispatch(props.fulfillUser(user))

            var {data: permissions} = await PermissionsClient.ForCurrentUser()

            if (permissions.data) {
              var mappedPermissions = permissions.data.map((p: any) => p.id)
              dispatch(props.setUserPermission(mappedPermissions))
            }

            dispatch(fetchAccountSettings())
          }
        }
      } catch (error) {
        console.error(error)
        // if (!didRequest.current) {
        //   dispatch(props.logout())
        // }
      } finally {
        setShowSplashScreen(false)
      }

      return () => (didRequest.current = true)
    }

    if (accessToken) {
      requestUser()
    } else {
      // dispatch(props.logout())
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(AuthInit)
